module.exports = __webpack_public_path__ + "static/pensjonat-wiosna_thumb-c5b1dd5c71af5cef1246aaba81b42327.jpg";